import { useEffect } from 'react';
import { useAuth } from '../auth/AuthContext';
import { initTelemetry } from '../../../../shared/telemetry';

// Story 20562: the consent exemption covers only a signed-in session. Anonymous
// sign-in, sign-up, claim and invite pages never load the SDK, so main.tsx must
// not call initTelemetry with consent: 'not-required'. Inert unless
// VITE_ADMIN_APPLICATIONINSIGHTS_CONNECTION_STRING is set.
export function SignedInTelemetry() {
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    if (!isAuthenticated) return;
    void initTelemetry({
      connectionString: import.meta.env.VITE_ADMIN_APPLICATIONINSIGHTS_CONNECTION_STRING,
      consent: 'not-required',
      role: 'chelless-admin',
    });
  }, [isAuthenticated]);

  return null;
}
